import { ReactElement } from 'react';
import { sepFormat } from 'utilities';
import { AddButton } from 'components';
import type { ApplicationType, LinkCandidate } from 'modules/applicator/types';
import { InvoiceWidget } from 'modules/invoicing/common/InvoiceWidget';
import { Table, Tbody, Td, Th, Thead, Tr } from '@ff-it/ui';
import { controlCol } from 'styles/style.css';

type CandidateListProps = {
  items: LinkCandidate[];
  applicationType: ApplicationType;
  actionHandler?: (item: LinkCandidate) => void;
};

export function CandidateList({ items, applicationType, actionHandler }: CandidateListProps): ReactElement {
  return (
    <Table data-testid="candidates" striped>
      <Thead>
        <Tr variant="dark">
          <Th>Candidate invoice</Th>
          <Th textAlign="right">Total amount</Th>
          <Th textAlign="right">Applicable amount</Th>
          <Th className={controlCol}></Th>
        </Tr>
      </Thead>
      <Tbody>
        {items.map((item) => {
          const { destination, amount } = item;

          const totalAmount = destination[applicationType === 'advance' ? 'total' : 'sub_total'];

          return (
            <Tr key={destination.id}>
              <Td>
                <InvoiceWidget invoice={destination} link />
              </Td>
              <Td textAlign="right" valign="middle">
                {sepFormat(totalAmount)}
              </Td>
              <Td textAlign="right" valign="middle">
                {sepFormat(amount)}
              </Td>
              <Td valign="middle">
                {actionHandler && (
                  <AddButton testId={`candidates-action-${destination.id}`} onClick={() => actionHandler(item)} />
                )}
              </Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
}
